import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const dialogId = createUniqueId();
const dialogContentId = createUniqueId();

let dialogBox = null;
let dialogContentBox = null;

const showDialog = () => {
    dom.$id(dialogId).style.display = 'flex';
};

const hideDialog = () => {
    dom.$id(dialogId).style.display = 'none';
};

const Dialog = (props = {}) => {
    const { contentComponent, isRightClose = false, onClose } = props;

    const data = {
        dialogId,
        dialogContentId,
        isRightClose,
        contentComponent
    };
    
    const events = {
        close: () => {
            hideDialog();
            onClose && onClose();
        },
    };

    if (!dialogBox) {
        const component = createComponent(tpl, { data, style }, events);
        document.body.insertAdjacentHTML('afterbegin', component);
        dialogBox = dom.$id(dialogId);
        dialogContentBox = dom.$id(dialogContentId);
    } else {
        dialogContentBox.innerHTML = contentComponent;
        dialogBox.style.cssText = 'display:flex';
    }

};


export default Dialog;
export { showDialog, hideDialog };
